module.exports = __webpack_public_path__ + "zm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/zm.svg
// module id = 1152
// module chunks = 0